export const filterKeys = {
    textSearch: 'text_search',
    categories: 'categories',
    sponsors: 'sponsors',
};
